import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as mqtt from "./utils/mqtt";
import * as auth from "./utils/auth";
import * as moment from "moment-jalaali";
import fa from "moment/locale/fa";
import NewLogin from "./views/new-login-page/NewLogin";

moment.locale("fa", fa);
moment.loadPersian({
    usePersianDigits: true,
    dialect: "persian-modern"
});

const loading = () => (
    <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/login-page/Login"));
const Logout = React.lazy(() => import("./views/logout-page/Logout"));
const Page404 = React.lazy(() => import("./views/404-page/Page404"));
const Page500 = React.lazy(() => import("./views/500-page/Page500"));


class App extends Component {


    render() {

        return (
            <>
                <BrowserRouter>
                    <React.Suspense fallback={loading()}>
                        <Switch>
                            <Route
                                exact
                                path="/login"
                                name="Login Page"
                                render={props => <Login {...props} />}
                            />
                            <Route
                                exact
                                path="/new-login"
                                name="Login Page"
                                render={props => <NewLogin {...props} />}
                            />
                            <Route
                                exact
                                path="/logout"
                                name="Logout"
                                render={props => <Logout {...props} />}
                            />
                            <Route
                                exact
                                path="/404"
                                name="Page 404"
                                render={props => <Page404 {...props} />}
                            />
                            <Route
                                exact
                                path="/500"
                                name="Page 500"
                                render={props => <Page500 {...props} />}
                            />
                            <Route
                                path="/"
                                name="Home"
                                render={props => <DefaultLayout {...props} />}
                            />
                        </Switch>
                    </React.Suspense>
                </BrowserRouter>
                <ToastContainer position={toast.POSITION.BOTTOM_LEFT} />
            </>
        );
    }
}

export default App;
